import React from 'react';
import { Create, SimpleForm, TextInput, FileInput, FileField } from 'react-admin';

const redirect = (basePath, id, data) => `/turbineTypes`;

// The Excel workbook is now the only way to create a turbine type - it
// carries the full register map (Coils/InputRegisters/HoldingRegisters/
// EnergyCounter) AND the State/Failure code-text lookups, all in one file
// (see Orbital-server/scripts/lib/turbineSchemaXlsx.js for the exact sheet
// layout). The server auto-creates the TurbineSchema row and imports every
// register/state/failure in one request - no separate "create schema" step.
const transform = (data) => new Promise((resolve, reject) => {
  if (!data.excelFile || !data.excelFile.rawFile) {
    reject(new Error('Please select an Excel (.xlsx) file'));
    return;
  }
  const reader = new FileReader();
  reader.readAsDataURL(data.excelFile.rawFile);
  reader.onload = () => resolve({ name: data.name, excelBase64: reader.result });
  reader.onerror = reject;
});

export default (props) => (
  <Create title="Create a new Turbine type" {...props} transform={transform}>
    <SimpleForm redirect={redirect}>
      <TextInput source="name" />
      <FileInput
        source="excelFile"
        label="Turbine type Excel (.xlsx)"
        accept=".xlsx"
        maxSize={10000000}
      >
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Create>
);
